import { isSyntheticPropertyOrListener } from '@angular/compiler/src/render3/util';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BillingDoIt } from '@classes/billing-do-it';
import { BillingToDo } from '@classes/billing-to-do';
import { BillingType } from '@enums/billing-type.enum';
import { BillingToDoService } from 'app/core/services/billing-to-do.service';
import { UiService } from 'app/core/services/ui.service';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-do-it-modal',
  templateUrl: './do-it-modal.component.html',
  styleUrls: ['./do-it-modal.component.scss']
})
export class DoItModalComponent implements OnInit {

  doItForm!: FormGroup;

  billingToDoList_Tonnage: BillingToDo[] = [];
  billingToDoList_Toll: BillingToDo[] = [];
  billingToDoList_Concession: BillingToDo[] = [];

  constructor(
    public dialogRef: MatDialogRef<DoItModalComponent>,
    private fb: FormBuilder,
    public uiService: UiService,
    private billingToDoService: BillingToDoService,
    @Inject(MAT_DIALOG_DATA) public data: BillingToDo[],
  ) { }

  ngOnInit() {
    this.initForm();
    this.initList();
  }
  private initForm(): void {
    this.doItForm = this.fb.group({
      date: new FormControl(null, [Validators.required]),
    });
  }

  private initList() {
    this.data.forEach(line => {
      // Tonnage = 1,
      // Toll = 2,
      // Concession = 3,
      switch (line.billingType) {
        case BillingType.Tonnage:
          this.billingToDoList_Tonnage.push(line);
          break;
        case BillingType.Toll:
          this.billingToDoList_Toll.push(line);
          break;
        case BillingType.Concession:
          this.billingToDoList_Concession.push(line);
          break;
      }
    })
  }

  onSubmit(): void {    
    this.uiService.addRouteLoading();
    const billingDoIt: BillingDoIt = new BillingDoIt({
      ids: this.data.map(m => m.id),
      date: moment(this.doItForm.get('date')?.value).format('YYYY-MM-DDTHH:mm')
    });
    this.billingToDoService.doIt(billingDoIt).subscribe(data => {
      this.dialogRef.close(true);
    }, error => {
      console.error(error);
    }, () => {
      this.uiService.removeRouteLoading();
    })
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

}
